import Background from '../../components/layout/Background'
import AppChrome from '../../components/AppChrome'
import Hero from '../../components/Hero'
import Activity from '../../components/activities/Activity'
import MetaTags from '../../components/MetaTags'

export { getServerSideProps } from '../../graphql/activity'

function ActivityPage( { entry: activity, letsMakePage } ) {
  return (
    <AppChrome>
      <MetaTags
        url={ `/lets-make/${ activity.slug }` }
        title={ `${ letsMakePage.title }: ${ activity.title }${ activity.subHeading && `, ${ activity.subHeading }` }` }
        image={ activity.activityImage?.[ 0 ]?.url }
      />
      <Background 
        $color="grey9"
      >
        <Hero 
          title={ activity.title }
          subheading={ activity.activityType.map( activityType => activityType.title ).join( ' / ' ) }
        />
        <Activity activity={ activity } />
      </Background>
    </AppChrome>
  )
}

export default ActivityPage
